import { useState } from 'react';
import { useBoolean } from 'minimal-shared/hooks';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Tooltip from '@mui/material/Tooltip';

import { useElementOnScreen } from 'src/hooks/use-intersection-observer';

import { useTranslate } from 'src/locales';
import { useGetReviews } from 'src/actions/reviews';

import { ReviewDrawer } from 'src/components/reviews';
import {
  ButtonShare,
  ButtonComments,
  ButtonAddToCart,
  ButtonAddFavorite,
} from 'src/components/custom-buttons';

import { GalleryCarousel } from './components/gallery-carousel';
import { ProductDescription } from './components/product-description';

// ----------------------------------------------------------------------

const collection = 'promotions';

export function ProductItem({ product, preview, searchParams }) {
  const { t } = useTranslate();

  const showReview = useBoolean();

  const { id, available, totalReviews } = product;

  const [openReviews, setOpenReviews] = useState(false);

  const reviewHook = useGetReviews(id, collection, openReviews);

  const { containerRef, isVisible } = useElementOnScreen({
    root: null,
    threshold: 1.0,
    rootMargin: '0px',
  });

  const renderActions = () => (
    <Box className="product__actions">
      <ButtonAddFavorite
        preview={preview}
        product={product}
        isLiked={searchParams?.list === 'favorites'}
      />

      <ButtonComments
        totalComments={openReviews ? reviewHook.totalReviews : totalReviews}
        onClick={() => {
          if (!preview && !openReviews) setOpenReviews(true);
          if (!preview) showReview.onTrue();
        }}
      />

      <ButtonShare preview={preview} product={product} />

      <Tooltip placement="left" title={!available && t('Out of stock')}>
        <ButtonAddToCart preview={preview} product={product} />
      </Tooltip>
    </Box>
  );

  return (
    <Card ref={containerRef} id={`gallery-slider-${id}`} className="scroll__snap__child">
      <GalleryCarousel preview={preview} product={product} isVisible={isVisible} />

      <ProductDescription
        preview={preview}
        product={product}
        reviewHook={reviewHook}
        openReviews={openReviews}
      />

      {renderActions()}

      {!preview && (
        <ReviewDrawer
          id={id}
          collection={collection}
          reviewHook={reviewHook}
          showReview={showReview}
        />
      )}
    </Card>
  );
}
